import request from '@/utils/request'

//课程列表
export function lessonList(data) {
	return request({
		url: '/business/platform/frontList',
		method: 'get',
		params: data
	})
}

//章节列表
export function chapterList(platformId) {
	return request({
		url: '/v1/business/chapter/list?platformId=' + platformId,
		method: 'get'
	})
}

//视频列表
export function videoList(chapterId) {
	return request({
		url: '/v1/business/video/list?chapterId=' + chapterId,
		method: 'get'
	})
}
//视频详情
export function platformVideo(chapterId) {
	return request({
		url: '/business/platformVideo/' + chapterId,
		method: 'get'
	})
}

export function checkUserIsPerfect() {
	return request({
		url: '/v1/business/checkUserIsPerfect',
		method: 'get'
	})
}

//检查用户是否已绑定该课程
export function checkUserHasBind(platformId) {
	return request({
		url: '/v1/business/checkUserHasBind?platformId=' + platformId,
		method: 'get'
	})
}

//苏学码绑定课程
export function bindCode(platformId, code) {
	return request({
		url: '/v1/business/bindCode?platformId=' + platformId + '&code=' + code,
		method: 'post'
	})
}

// 课程获取试卷
export function genPaper(baseId, type) {
	return request({
		url: '/business/paperInfo/genPaper?platformId=' + baseId + '&type=' + type,
		method: 'get'
	})
}
//试卷id获取试卷
export function genPaperByPaperId(baseId) {
	return request({
		url: '/business/paperInfo/genPaperByPaperId?paperId=' + baseId,
		method: 'get'
	})
}
//提交试卷
export function submitPaper(data) {
	return request({
		url: '/v1/business/submitPaper',
		method: 'post',
		data: data
	})
}
//生成订单
export function native(data) {
	return request({
		url: '/v1/pay/native',
		method: 'post',
		data: data
	})
}
export function viewPager(platformId) {
	return request({
		url: '/business/viewPager/frontList?type='+platformId,
		method: 'get'
	})
}
//查询订单状态
export function initLessonList(platformId) {
	return request({
		url: '/v1/business/video/initList?platformId='+platformId,
		method: 'get'
	})
}
//取消订单
export function cancelOrder(orderNo) {
	return request({
		url: '/v1/pay/cancel/' + orderNo,
		method: 'post'
	})
}
//查询订单状态
export function orderStatus(orderNo) {
	return request({
		url: '/v1/pay/query-order-status/' + orderNo,
		method: 'get'
	})
}
//校验是否考试
export function paperVerify(orderNo) {
	return request({
		url: '/v1/business/paper/verify/' + orderNo,
		method: 'get'
	})
}
//心跳初始化
export function heartBeatInit(data) {
	return request({
		url: '/aliVod/heartBeatInit',
		method: 'get',
		params:data
	})
}
//发送心跳
export function heartbeat(data) {
	return request({
		url: '/aliVod/heartbeat',
		method: 'post',
		data: data
	})
}
export function noticeList(data) {
	return request({
		url: '/system/notice/frontList',
		method: 'get',
		params:data
	})
}
export function getNotice(orderNo) {
	return request({
		url: '/system/notice/' + orderNo,
		method: 'get'
	})
}
export function answerJudgment(data) {
	return request({
		url: '/v1/business/answerJudgment',
		method: 'post',
		params:data
	})
}
